export const CUSTOM_SUPPLIER_ID = 'custom-supplier'
export const CUSTOM_PRODUCT_ID = 'custom-product'
